import Workload from './workload';

export default class StatefulSet extends Workload {
}
